module.exports = __webpack_public_path__ + "components/country-flag/static/ms-cf8343068c60bad474f63c4a38542575.svg";